"use client";

import Link from "next/link";
import React from "react";
import { useTranslation } from "react-i18next";

import config from "../../services/config";

import MenuEntry from "./MenuEntry";

interface Props {
  className?: string;
  closeMenu?: () => void;
}

const Menu: React.FC<Props> = ({ className, closeMenu }) => {
  const { t } = useTranslation("common");

  const onMenuLinkClick = (e) => {
    if (e.target.href && closeMenu) closeMenu();
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      className={`justify-between md:items-center w-max pt-1 ${className}`}
      onClick={(e) => onMenuLinkClick(e)}
    >
      <div className="mr-4 hover"><MenuEntry link={<Link href="/" data-pw="menuExperts">{t("menu.experts")}</Link>} /></div>
      <div className="mr-4 hover"><MenuEntry link={<Link href="/packs" data-pw="menuPricing">{t("menu.pricing")}</Link>} /></div>
      <div className="mr-4 hover"><MenuEntry link={<Link href="/reviews">{t("menu.customerReviews")}</Link>} /></div>
      <div className="mr-4 hover"><MenuEntry link={<Link href="/horoscope" data-pw="menuHoroscope">{t("menu.horoscope")}</Link>} /></div>
      <div className="mr-4 hover"><MenuEntry link={<Link href="/blog" data-pw="menuBlog">{t("menu.blog")}</Link>} /></div>
      <div className="mr-4" data-pw="menuHelpAndSupport">
        <MenuEntry link={t("menu.helpAndSupport")}>
          <Link href="/terms-conditions" data-pw="menuTermsAndConditions">{t("menu.termesAndConditions")}</Link>
          <Link href="/faq" data-pw="menuFAQ">{t("menu.faq")}</Link>
          <Link href="/skills" data-pw="menuSkills">{t("menu.skills")}</Link>
          <a href={`${config.app.expertApp}/become-expert`} data-pw="menuBecomeExpert" target="_blank" rel="noreferrer">{t("menu.becomeExpert")}</a>
          <Link href="/support">{t("menu.support")}</Link>
        </MenuEntry>
      </div>
    </div>
  );
};

export default Menu;
